<template>
  <div class="header">
    <div class="title">
<!--      {{$i18n.translate(title)}}-->
    </div>
<!--    <div class="lang">-->
<!--      <span @click="changeLang('ko')">Ko</span> |-->
<!--      <span @click="changeLang('en')">En</span>-->
<!--    </div>-->
    <div class="close" v-on:click="close">
      Close
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "custom-header",
  props: ['title'],
  methods: {
    changeLang: function(lang){
      this.$i18n.setLocale(lang);
      window.location.href = "/";
    },
    close: function(){
      window.open('', '_self', '');
      window.close();
    }
  }
}
</script>

<style scoped>

</style>
